<div
  class="avatar-iniciales"
  [ngClass]="[
    size,
    isHovered ? 'avatar-iniciales-hover' : '',
    activo ? 'activo' : ''
  ]"
>
  <ng-container *ngIf="!mostrarIcono; else iconoGenerico">
    <span *ngIf="activo" matTooltip="{{ nombreCompleto() }}" class="avatar-text">
      {{ iniciales }}
    </span>
    <span *ngIf="!activo" matTooltip="Usuario {{ nombreCompleto() }}." class="avatar-text">
      {{ iniciales }}
    </span>

  </ng-container>
 <ng-template #iconoGenerico>
  <mat-icon *ngIf="activo" class="avatar-icon">person</mat-icon>
  <mat-icon *ngIf="!activo" matTooltip="Sin usuario asignado." class="avatar-icon">person</mat-icon>
</ng-template>

</div>
